/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentType({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/NextAppointment/Content/Content/Content/Appointment/AppointmentType"
  
}) {
let upcomingAppointmentAppointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'upcoming_appointment',
path: 'appointment.type.display_name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="upcoming_appointment.appointment.type.display_name"
 text={upcomingAppointmentAppointmentTypeDisplayNameValueData}
 weight="medium"
 size="small"
 maxWidth={120}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 display="inline-block"
/>
{children}
</React.Fragment>)
}